<template>
  <v-dialog width="60%" :model-value="show" persistent scrollable eager>
    <v-card>
      <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title>
        {{ this.isEditMode ? 'Modifier un matériau' : 'Ajouter un matériau' }}
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-tabs bg-color="primary" color="white" v-model="activeTab">
            <v-tab class="text-white"> Informations </v-tab>
            <v-tab class="text-white"> Assemblages </v-tab>
          </v-tabs>
          <v-tabs-window v-model="activeTab">
            <v-tabs-window-item eager>
              <modal-custom-material-information-form
                ref="informationForm"
                :material="material"
                :show="show"
                :formValid="formValid"
                :forceResetForm="forceResetForm"
                @update-form-validity="updateFormValidity"
                @update-force-reset-form="forceResetForm = false"
              ></modal-custom-material-information-form>
            </v-tabs-window-item>
            <v-tabs-window-item eager>
              <modal-custom-material-composites
                :material="material"
                :show="show"
                :hideActions="false"
                :forceResetComposites="forceResetComposites"
                @update-associated-composites="updateAssociatedComposites"
                @update-force-reset-composites="forceResetComposites = false"
              >
              </modal-custom-material-composites>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="cancel"> Annuler </v-btn>
        <v-btn color="primary" variant="text" @click="save" :disabled="!formValid"> Confirmer </v-btn>
      </v-card-actions>
      <loading-spinner v-if="loading"></loading-spinner>
      <v-snackbar v-model="showSnackBar" :timeout="6000" color="error" y="bottom">
        {{ snackBarText }}
        <v-btn variant="text" @click="showSnackBar = false">Fermer</v-btn>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import { Create, Edit, Get } from '@/_services/userMaterials';
import ModalCustomMaterialInformationForm from '@/components/material/ModalCustomMaterialInformationForm';
import ModalCustomMaterialComposites from '@/components/material/ModalCustomMaterialComposites';
import LoadingSpinner from '@/components/LoadingSpinner';
export default {
  name: 'ModalCustomMaterial',
  components: {
    ModalCustomMaterialInformationForm,
    ModalCustomMaterialComposites,
    LoadingSpinner,
  },
  props: {
    show: {
      type: Boolean,
    },
    mode: {
      type: String,
      required: true,
    },
    materialId: {
      type: Number,
    },
  },
  data() {
    return {
      activeTab: 0,
      loading: false,
      snackBarText: '',
      showSnackBar: false,
      formValid: false,
      forceResetForm: false,
      forceResetComposites: false,
      material: {
        id: 0,
        name: '',
        unit: null,
        labor: null,
        laborHourlyRate: '',
        unitPrice: 0,
        laborConstant: 0,
        userPrice: 0,
        associatedComposites: [],
      },
    };
  },
  computed: {
    isEditMode() {
      return this.mode === 'edit';
    },
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      Get(this.materialId)
        .then(rep => {
          this.material.id = rep.materialPrototype.id;
          this.material.name = rep.materialPrototype.name;
          this.material.unit = rep.materialPrototype.unit;
          this.material.labor = rep.materialPrototype.labor;
          this.material.laborHourlyRate = rep.materialPrototype.laborHourlyRate;
          this.material.unitPrice = rep.materialPrototype.unitPrice;
          this.material.laborConstant = rep.materialPrototype.laborConstant;
          this.material.userPrice = rep.materialPrototype.userPrice;
          this.material.associatedComposites = rep.compositePrototypes;
        })
        .catch(error => {
          this.snackBarText = error;
          this.showSnackBar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.forceResetForm = true;
      this.forceResetComposites = true;
      this.activeTab = 0;
      this.resetData();
      this.$emit('close');
    },
    save() {
      this.loading = true;
      const item = {
        id: this.material.id,
        name: this.material.name,
        unitId: this.material.unit.id ? this.material.unit.id : this.material.unit,
        unitPrice: Number(this.material.unitPrice),
        laborConstant: Number(this.material.laborConstant),
        laborId: this.material.labor.id ? this.material.labor.id : this.material.labor,
        compositePrototypeIds: this.material.associatedComposites.map(x => x.id),
      };

      if (this.isEditMode) {
        this.update(item);
      } else {
        this.create(item);
      }
    },
    update(item) {
      Edit(item)
        .then(() => {
          this.forceResetForm = true;
          this.forceResetComposites = true;
          this.resetData();
          this.$emit('close');
        })
        .catch(error => {
          this.snackBarText = error;
          this.showSnackBar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create(item) {
      Create(item)
        .then(() => {
          this.forceResetForm = true;
          this.forceResetComposites = true;
          this.resetData();
          this.$emit('close');
        })
        .catch(error => {
          this.snackBarText = error;
          this.showSnackBar = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetData() {
      this.activeTab = 0;
      this.formValid = false;
      this.material = {
        id: 0,
        name: '',
        unit: null,
        labor: null,
        laborHourlyRate: '',
        unitPrice: 0,
        laborConstant: 0,
        associatedComposites: [],
      };
    },
    updateAssociatedComposites(value) {
      this.material.associatedComposites = value;
    },
    updateFormValidity(value) {
      this.formValid = value;
    },
  },
  watch: {
    mode(newVal) {
      if (newVal === 'edit') {
        this.getDataFromApi();
      }
    },
  },
};
</script>
